import classNames from 'classnames';
import React from 'react';
import PropTypes from 'prop-types';
import * as Styles from './avatar-select.module.scss';
import Avatar, { avatarList } from './avatar';

function AvatarSelect({ className, changeAvatarHandler, avatar, theme }) {
  function changeAvatar(changeBy) {
    const avatarIndex = avatarList.findIndex((name) => name === avatar) ?? 0;

    if (changeBy > 0) {
      changeAvatarHandler(avatarList[avatarIndex + 1] ?? avatarList[0]);
    } else if (changeBy < 0) {
      changeAvatarHandler(avatarList[avatarIndex - 1] ?? avatarList[avatarList.length - 1]);
    }
  }

  return (
    <div className={classNames(Styles.root, className)} data-theme={theme}>
      {/* eslint-disable-next-line jsx-a11y/control-has-associated-label */}
      <button
        title="previous avatar"
        className={classNames(Styles.selectButton, Styles.selectButtonL)}
        type="button"
        onClick={() => changeAvatar(-1)}
      />
      <Avatar className={Styles.avatar} avatar={avatar ?? avatarList[0]} />
      {/* eslint-disable-next-line jsx-a11y/control-has-associated-label */}
      <button
        title="next avatar"
        className={classNames(Styles.selectButton, Styles.selectButtonR)}
        type="button"
        onClick={() => changeAvatar(1)}
      />
    </div>
  );
}

AvatarSelect.propTypes = {
  theme: PropTypes.string,
  className: PropTypes.string,
  changeAvatarHandler: PropTypes.func,
  avatar: PropTypes.string,
};

AvatarSelect.defaultProps = {
  theme: 'default',
  className: null,
  changeAvatarHandler: false,
  avatar: avatarList[0],
};

export default AvatarSelect;
